import { motion, Variants } from 'framer-motion';
import CommonChestContain from '../../../assets/images/chests/rewards/common-reward-body.png';
import EpicChestContain from '../../../assets/images/chests/rewards/epic-reward-body.png';
import EpicShine from '../../../assets/images/chests/glows/epic-glow.png';
import GalaxyChestShine from '../../../assets/images/chests/glows/galaxy-glow.png';
import GalaxyChestImg from '../../../assets/images/chests/opened/galaxy-chest.png';
import LaunchChestImg from '../../../assets/images/chests/opened/launch-chest.png';
import LegendaryChestContain from '../../../assets/images/chests/rewards/legendary-reward-body.png';
import LegendaryShine from '../../../assets/images/chests/glows/legendary-glow.png';
import OrbitChestImg from '../../../assets/images/chests/opened/orbit-chest.png';
import RareChestContain from '../../../assets/images/chests/rewards/rare-reward-with-glow.png';
import SupernovaChestImg from '../../../assets/images/chests/opened/supernova-chest.png';
import { TChestRewardVariant, TChestVariant } from '../../../types';

type TChestRewardType = `${TChestVariant}-${TChestRewardVariant}`

const shineAnimation: Variants = {
  initial: {
    rotate: 0,
  },
  animate: {
    rotate: 360,
    transition: {
      duration: 10, repeat: Infinity, repeatDelay: 0, repeatType: 'loop', ease: 'linear',
    },
  },
};

export const getChestRewardIcons = (chestRewardType: TChestRewardType) => {
  let chest = null;
  let reward = null;
  let shine = null;
  let chestShine = null;

  const styles = {
    chest: 'absolute z-[-1] left-[50%] top-[50%] transform translate-x-[-50%] translate-y-[-50%]',
    reward: '',
    shine: '',
    chestShine: 'absolute inset-0 top-[57.5%] translate-y-[-50%] w-full h-full scale-[2] z-[-1]',
  };

  switch (chestRewardType) {
    case 'launch-common':
      chest = LaunchChestImg;
      reward = CommonChestContain;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%)] transform translate-y-[-50%] translate-x-[-50%]';

      break;
    case 'launch-rare':
      chest = LaunchChestImg;
      reward = RareChestContain;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+24px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'launch-epic':
      chest = LaunchChestImg;
      reward = EpicChestContain;
      shine = EpicShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%+8px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-12px)] left-[calc(50%+18px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'launch-legendary':
      chest = LaunchChestImg;
      reward = LegendaryChestContain;
      shine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'orbit-common':
      chest = OrbitChestImg;
      reward = CommonChestContain;

      styles.reward = 'absolute top-[calc(50%-14px)] left-[calc(calc(50%-6px))] transform translate-y-[-50%] translate-x-[-50%]';

      break;
    case 'orbit-rare':
      chest = OrbitChestImg;
      reward = RareChestContain;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+24px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'orbit-epic':
      chest = OrbitChestImg;
      reward = EpicChestContain;
      shine = EpicShine;

      styles.reward = 'absolute top-[calc(50%-12px)] left-[calc(50%+2px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+12px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'orbit-legendary':
      chest = OrbitChestImg;
      reward = LegendaryChestContain;
      shine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-12px)] left-[calc(50%+8px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'galaxy-common':
      chest = GalaxyChestImg;
      reward = CommonChestContain;
      chestShine = GalaxyChestShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%)] transform translate-y-[-50%] translate-x-[-50%]';

      break;
    case 'galaxy-rare':
      chest = GalaxyChestImg;
      reward = RareChestContain;
      chestShine = GalaxyChestShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+24px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'galaxy-epic':
      chest = GalaxyChestImg;
      reward = EpicChestContain;
      shine = EpicShine;
      chestShine = GalaxyChestShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%+8px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-12px)] left-[calc(50%+18px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'galaxy-legendary':
      chest = GalaxyChestImg;
      reward = LegendaryChestContain;
      shine = LegendaryShine;
      chestShine = GalaxyChestShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'supernova-common':
      chest = SupernovaChestImg;
      reward = CommonChestContain;
      chestShine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-18px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%]';

      break;
    case 'supernova-rare':
      chest = SupernovaChestImg;
      reward = RareChestContain;
      chestShine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-12px)] left-[calc(50%+12px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+24px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'supernova-epic':
      chest = SupernovaChestImg;
      reward = EpicChestContain;
      shine = EpicShine;
      chestShine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-12px)] left-[calc(50%+12px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+24px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    case 'supernova-legendary':
      chest = SupernovaChestImg;
      reward = LegendaryChestContain;
      shine = LegendaryShine;
      chestShine = LegendaryShine;

      styles.reward = 'absolute top-[calc(50%-12px)] left-[calc(50%+12px)] transform translate-y-[-50%] translate-x-[-50%]';
      styles.shine = 'absolute top-[calc(50%-6px)] left-[calc(50%+6px)] transform translate-y-[-50%] translate-x-[-50%] z-[-1]';

      break;
    default:
      chest = LaunchChestImg;
      reward = CommonChestContain;
      break;
  }

  return {
    chest: <img src={chest} alt="chest" className={styles.chest} />,
    reward: <img src={reward} alt="chest-reward" className={styles.reward} />,
    shine: shine && (
    <div className={`${styles.shine} w-full h-full`}>
      <motion.img
        src={shine}
        alt="chest-shine"
        initial="initial"
        animate="animate"
        variants={shineAnimation}
      />
    </div>
    ),
    chestShine: chestShine && (
      <img
        src={chestShine}
        className={styles.chestShine}
        alt="chest-shine"
      />
    ),
  };
};
